import { render, staticRenderFns } from "./addAdmission.vue?vue&type=template&id=18881b21&scoped=true"
import script from "./addAdmission.vue?vue&type=script&lang=js"
export * from "./addAdmission.vue?vue&type=script&lang=js"
import style0 from "./addAdmission.vue?vue&type=style&index=0&id=18881b21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18881b21",
  null
  
)

export default component.exports